import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { unpack_validation } from 'z3k-parser/validation/types';
import { Scenario } from 'z3k-config';
import { useBox } from 'shared/hooks/utils';
import { TurnOn } from '../material-utils/turn-on';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
export function ScenariosList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const configBox = useBox(config);
    const { device_spec, deviceFirmwareVersion } = useContext(Z3KSettings);
    const onTurnOnScenario = useCallback((scenario) => (active) => {
        replace_config(Scenario.get.replaceById(configBox.current, scenario.id, Scenario.setActive(scenario, active)));
    }, [replace_config]);
    const titleComponentRender = useCallback((scenario, selected) => deviceFirmwareVersion >= 185 ? (_jsx(TurnOn, { selected: selected, is_active: Scenario.isActive(scenario), onChange: onTurnOnScenario(scenario) })) : null, [device_spec, onTurnOnScenario]);
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "scenarios", help_id: "scenarios_list", item_url: Z3kSecondRoutes.scenarios, name: RouteNaming[Z3kSecondRoutes.scenarios], titleComponentRender: titleComponentRender, selected_item_id: selected_item_id }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
const fields = ['scenarios'];
ScenariosList.isError = (validation_result) => fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
ScenariosList.isWarning = ScenariosList.isError;
ScenariosList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => {
    return (!is_climatic &&
        parseInt(config.device?.firmware, 10) >= 89 &&
        device_spec.has_scenarios &&
        (device_spec.has_service_mode ? is_service_view : true));
};
